import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

const TOKEN_KEY = "bevel_admin_token";

export const setAdminToken = (token) => {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
};

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);

export const adminApi = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

adminApi.interceptors.request.use((config) => {
    const token = getAdminToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

adminApi.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            setAdminToken(null);
        }
        return Promise.reject(err);
    },
);
